// import { createStore, applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';
// import rootReducer from './reducers'; // Adjust the path to your root reducer

// const store = createStore(rootReducer, applyMiddleware(thunk));

// export default store;


// import { createStore, applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';
// import rootReducer from './reducer'; // Adjust the path to your root reducer

// const store = createStore(rootReducer, applyMiddleware(thunk));

// export default store;


// src/store/index.ts
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import rootReducer from './reducer'; // Adjust path to your root reducer

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

